<template>
	<div class="news-wrap">
		<el-form ref="form" :model="form" :rules="rules" label-width="100px">
			<el-card class="box-card">
				<div class="title">
					专家照片
				</div>
				<div class="details">
					照片详情备注
				</div>
				<el-form-item prop="news_photo">
					<el-upload class="avatar-uploader" :action="picUrl" 
						:show-file-list="false"
						element-loading-text="拼命加载中……"
						:on-progress="change"
						:before-upload="beforeAvatarUpload" :data="fileInfo"
						:on-success="handleAvatarSuccess" accept="image/jpeg,image/png">
						<img v-if="imageUrl" :src="imageUrl"  :onerror="imgSrc" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item>
			</el-card>
			<el-card class="box-card cardBox">
				<div class="title">
					基本信息
				</div>
				<div class="countsBoxs">
					 <div class="inputBigBoxs">
						 <el-form-item label="专家姓名" prop="relname">
						   <el-input v-model="form.relname" placeholder="请输入专家姓名"></el-input>
						 </el-form-item>
						 <el-form-item label="联系电话" prop="phone">
						   <el-input v-model="form.phone" placeholder="请输入联系电话"></el-input>
						 </el-form-item>
						 <el-form-item label="行业专家" prop="cat_id">
						   <el-select v-model="form.cat_id" placeholder="请输入行业专家">
						       <el-option
						         v-for="item in options"
						         :key="item.id"
						         :label="item.catname"
						         :value="item.id">
						       </el-option>
						     </el-select>
						 </el-form-item>
						 <el-form-item label="从业时间" prop="congye_age">
						   <el-input v-model="form.congye_age" placeholder="1958-至今"/>
						 </el-form-item>
						  <el-form-item label="所在地" prop="addressData">
							<area-select v-model="addressData" type="text" :data="pcaa" :level="1" @change="handleAddressChange" />
						  </el-form-item>
						  <el-form-item label="详细地址" prop="address">
							<el-input v-model="form.address"/>
						  </el-form-item>
						 <el-form-item label="毕业院校"  prop="biye">
						   <el-input v-model="form.biye" placeholder="请输入毕业院校"></el-input>
						 </el-form-item>
						 <el-form-item label="所在单位" prop="danwei">
						   <el-input v-model="form.danwei" placeholder="请输入所在单位"></el-input>
						 </el-form-item>
						 <el-form-item label="职位/职称" prop="zhiwei">
						   <el-input v-model="form.zhiwei" placeholder="请输入职位"></el-input>
						 </el-form-item>
					 </div>
					  <el-form-item label="简介" prop="jianjie">
						<tinyMce :content="form.jianjie" :change.sync="form.jianjie" />
					  </el-form-item>
					  <el-form-item label="案例" prop="anli">
						<tinyMce :content="form.anli" :change.sync="form.anli" />
					  </el-form-item>
					  <el-form-item label="专业方向" prop="zhuanchang">
						<tinyMce :content="form.zhuanchang" :change.sync="form.zhuanchang" />
					  </el-form-item>
					  <el-form-item label="服务项目" prop="fuwu">
						<tinyMce :content="form.fuwu" :change.sync="form.fuwu" />
					  </el-form-item>
					  <div class="submit-wrap">
						<el-button type="primary" @click="handleSubmit">提交</el-button>
					  </div>
				</div>
			</el-card>
		</el-form> 
	</div>
</template>

<script>
	import tinyMce from '@/components/plug/tinyMce'
	import {
		pca,
		pcaa
	} from 'area-data'
	import 'vue-area-linkage/dist/index.css'
	export default {
		data() {
			return {
				address:'',
				pca,
				pcaa,
				picUrl:'',
				imageUrl:'',
				user_id: this.$store.state.USER_ID,
				imgSrc: 'this.src="' + require('../../assets/img/mr.jpg') + '"',
				fileInfo:{
					type:"Member"
				},
				addressData:[],
				form:{
					id:''
				},
				options:[],
				rules: {
					news_photo:[{
						required: true,
						validator: (rule, value, callback) => {
							if (this.form.headimg == '' || this.form.headimg == undefined || this.form.headimg == null) {
								callback(new Error('请上传专家照片'));
							} else {
								callback();
							}
						}
					}],
					relname: [{
						required: true,
						message: '请填写专家姓名'
					}],
					phone: [{
						required: true,
						message: '请填写手机号码'
					}],
					cat_id:[{
						required: true,
						validator: (rule, value, callback) => {
							if (value == '' || value == undefined || value == null) {
								callback(new Error('请选择分类'));
							} else {
								callback();
							}
						}
					}],
					congye_age: [{
						required: true,
						message: '请填写从业时间'
					}],
					addressData:[{
						required: true,
						validator: (rule, value, callback) => {
							if (this.form.sheng == '' || this.form.sheng == undefined || this.form.sheng == null) {
								callback(new Error('请选择地址'));
							} else {
								callback();
							}
						}
					}],
					address: [{
						required: true,
						message: '请填写详细地址'
					}],
					biye: [{
						required: true,
						message: '请填写毕业院校'
					}],
					danwei: [{
						required: true,
						message: '请填写单位名称'
					}],
					zhiwei: [{
						required: true,
						message: '请填写职位'
					}],
					jianjie:[{
						required: true,
						validator: (rule, value, callback) => {
							if (this.form.jianjie === '') {
								callback(new Error('请填写简介'));
							} else {
								callback();
							}
						}
					}],
					anli:[{
						required: true,
						validator: (rule, value, callback) => {
							if (this.form.anli === '') {
								callback(new Error('请填写案例'));
							} else {
								callback();
							}
						}
					}],
					zhuanchang:[{
						required: true,
						validator: (rule, value, callback) => {
							if (this.form.zhuanchang === '') {
								callback(new Error('请填写专业方向'));
							} else {
								callback();
							}
						}
					}],
					fuwu:[{
						required: true,
						validator: (rule, value, callback) => {
							if (this.form.fuwu === '') {
								callback(new Error('请填写提供服务项目'));
							} else {
								callback();
							}
						}
					}],
				},
			}
		},
		created() {
			this.picUrl = this.$store.state.BASE_URL+'/uploadImgOne.html'
			this.$axios.post('/Myseller-setting-getshop').then(data => {
				if(data.data){
					let ade = []
					ade.push(data.sheng)
					ade.push(data.shi)
					this.addressData = ade
				}
				this.from.sheng = data.sheng
				this.from.shi = data.shi
			})
			// 获取分类
			this.getOptions()
		},
		methods: {
			getOptions(){
				this.$axios.post('/Myseller-setting-getcat').then(data => {
					this.options = data
					
				})
			},
			handleAddressChange(data) {
				this.form.sheng = data[0]
				this.form.shi = data[1]
				this.addressData = data
			},
			change(event, file, fileList) {
				this.loading = true;
			},
			beforeAvatarUpload(file){
				const isJPG = file.type === 'image/jpeg';
				const isPNG = file.type === 'image/png';
				const isLt5M = file.size / 1024 / 1024 < 5;
				if (!isJPG && !isPNG) {
					this.$message.error('上传图片只能是 JPG/PNG 格式!');
				}
				if (!isLt5M) {
					this.$message.error('上传图片大小不能超过 5MB!');
				}
				return (isJPG || isPNG) && isLt5M;
			},
			handleAvatarSuccess(res, file) {
				if (res.src != null) {
					this.loading = false;
					this.form.headimg = res.src
					this.imageUrl = URL.createObjectURL(file.raw);
				} else {
					this.loading = false;
					this.$message.error(res.data);
				}
			},
			handleSubmit(){
				this.$refs['form'].validate(valid => {
					if (valid) {
						if (this.form.jianjie.includes('"static/tinymce/plugins/bdmap/bd')) {
							this.form.jianjie = this.form.jianjie.replace(
								/"static\/tinymce\/plugins\/bdmap\/bd/g,
								'"/static/tinymce/plugins/bdmap/bd')
						}
						if (this.form.anli.includes('"static/tinymce/plugins/bdmap/bd')) {
							this.form.anli = this.form.anli.replace(
								/"static\/tinymce\/plugins\/bdmap\/bd/g,
								'"/static/tinymce/plugins/bdmap/bd')
						}
						if (this.form.zhuanchang.includes('"static/tinymce/plugins/bdmap/bd')) {
							this.form.zhuanchang = this.form.zhuanchang.replace(
								/"static\/tinymce\/plugins\/bdmap\/bd/g,
								'"/static/tinymce/plugins/bdmap/bd')
						}
						if (this.form.fuwu.includes('"static/tinymce/plugins/bdmap/bd')) {
							this.form.fuwu = this.form.fuwu.replace(
								/"static\/tinymce\/plugins\/bdmap\/bd/g,
								'"/static/tinymce/plugins/bdmap/bd')
						}
						this.$emit('eventForm', this.form)
					} else {
						this.$message.error('请补全必填项')
						return false
					}
				});
			},
			open(row){
				this.dialogVisible = true
				
			},
			handleAdd() {
				this.$router.push('/expertTeam/release')
			}
		},
		components:{
			tinyMce,
			pca,
			pcaa
		},
		props: {
			newsForm: {
				type: Object,
				default () {
					return {}
				}
			}
		},
		watch: {
			newsForm(val) {
				this.form = val
				this.form.id = val.id
				this.imageUrl = val.headimg ? this.$store.state.IMG_URL + val.headimg : ''
				this.addressData = [val.sheng, val.shi]
			}
		}
	}
</script>

<style scoped>
	.el-form{
		width: 98%;
		margin: 0 auto;
	}
	.inputBigBoxs{
		margin-top: 20px;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
	}
	.inputBigBoxs el-form-item{
		margin-right: 20px;
	}
	.cardBox{
		margin-top: 20px;
	}
	.el-input{
		width: 350px !important;
	}
	.el-form-item >>>.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}
	
	.el-form-item >>>.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}
	
	.el-form-item >>>.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}
	
	.el-form-item>>>.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}
	.el-form-item__content{
		line-height:inherit !important;
		margin-right: 20px;
		margin-left: 0 !important;
	}
	.area-select{
		z-index: 10000;
	}
	.box-card .title{
		font-size: 16px;
		font-weight: bold;
		
	}
	.box-card .details{
		font-size: 14px;
		color: #666;
		line-height: 40px;
	}
	.el-form-item>>>.area-select .area-selected-trigger{
		line-height: 19px !important;
	}
	.area-select.medium{
		width: 171px !important;
	}
	.el-form-item>>>.area-select-wrap .area-select{
		margin-left: 0 !important;
	}
	.el-card{
		overflow: initial;
	}
	.el-select{
		width: 350px !important;
	}
</style>